<template>
	<div class="news">
		<van-nav-bar fixed @click-left="onClickLeft">
			<template #left>
				<img src="../assets/img/icon/left-arrow.png" class="icon" />
			</template>
			<template #title>
				<img src="../assets/logo_horizontal.jpg" style="height:38px;margin-top:10px;"/>
			</template>
			<template #right>
				<van-icon name="share" @click="shareNewsInfo"/>
			</template>
		</van-nav-bar>
		
		<div class="news-title"><h1>{{qryNews.title}}</h1></div>
		<div class="news-note">
			<span>{{qryNews.date}}</span>
			<span>来源：{{qryNews.author_name}}</span>
		</div>
		<div class="news-size">
			字号
			<span @click="resetContentFontSize('small')">小</span>
			<span @click="resetContentFontSize('middle')">中</span>
			<span @click="resetContentFontSize('large')">大</span>
		</div>
		<div :class="'news-content'+' news-cont-size-'+cont_font_size" v-html="recompile(content)"></div>
		<div class="news-state">
			<div class="news-state-line"></div>
			※  如有侵权，请联系删除！
		</div>

		
		<share :showShareSheet.sync="showShareSheet" :shareUrl="shareQRCodeUrl" :shareConfig="shareConfig" :botm="0" v-show="showShareSheet" v-if="initShareSheet"/>
	</div>
</template>

<script type="text/ecmascript-6">
import { chkWeiXin } from "@/utils/common.js";
import Share from "@/components/Commom/Share";

export default {
	name: "store",
	components: {
		"share":Share
	},
	props:{
	},
	data() {
		return {
			title: "",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			attach_url:this.Conf.serverPre,
			qryNews:{},
			content:{},
			cont_font_size:'small',

			
			showShareSheet:false,
			shareQRCodeUrl:'',
			shareConfig:{},
			initShareSheet:false

		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
		
	},
	created() {
		this.getStateConfigs();
		this.n_id = this.$route.params.n_id;
		this.qryNews = this.$route.query

		let isWxEnv = chkWeiXin();
		this.shareQRCodeUrl = isWxEnv?location.href:(this.Conf.clientOrigin+'/m/#/News/Info/'+this.n_id);
		
		if(this.qryNews && this.qryNews.title){
			this.shareConfig = {
				title:this.qryNews.title,
				desc:'【'+top._SHARE_INFO.title+'】'+top._SHARE_INFO.desc,
				link:this.shareQRCodeUrl,
				imgUrl:this.getShareImgUrl(this.qryNews.thumbnail_pic_s)
			};
		}
		this.loadData();
	},
	methods: {
		// 返回
		onClickLeft() {
			this.$router.push({path:'/News'});
		},
		getStateConfigs(){
			const navs = this.$store.state.common.news_nav;
			if(navs){
				this.newsNav = navs;
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		loadData() {
			var params = {
				qry_info:this.qryNews&&this.qryNews.uniquekey?0:1
			};
			var url = this.Conf.serverUrl + "news/content/" + this.n_id +"?num="+Math.random();
			let that = this;
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				if (response.data.code == 200) {
					that.content = response.data.content;
					if(response.data.info){
						that.qryNews = response.data.info;
					}

					that.shareConfig = {
						title:that.qryNews.title,
						desc:'【'+top._SHARE_INFO.title+'】'+top._SHARE_INFO.desc,
						link:that.shareQRCodeUrl,
						imgUrl:that.getShareImgUrl(that.qryNews.thumbnail_pic_s)
					};
					
				}
				that.initShareSheet = true;
			})
			.catch(error => {
				that.initShareSheet = true;
			});
		},
		resetContentFontSize(t){
			this.cont_font_size = t;
		},
		getShareImgUrl(url){
			if(url){
				return url.indexOf('http')==-1?(this.attach_url+url):url;
			}
			return this.Conf.clientOrigin+'/statics/logo_h5.png';
		},
		shareNewsInfo(){
			this.showShareSheet = true;
		},
		recompile(cont){
			let hml = cont.content||'内容加载中……';
			let imgHml = '';
			let tmpimg = '';
			if(cont.pic_1){
				tmpimg = '<div><img src="'+(cont.pic_1.indexOf('http')==-1?(this.attach_url+cont.pic_1):cont.pic_1)+'" width="100%"/></div>';
				if(hml.indexOf('#PLATE_PIC_1#')>-1){
					hml = hml.replace('#PLATE_PIC_1#',tmpimg)
				}else{
					imgHml += tmpimg
				}
			}
			if(cont.pic_2){
				tmpimg = '<div><img src="'+(cont.pic_2.indexOf('http')==-1?(this.attach_url+cont.pic_2):cont.pic_2)+'" width="100%"/></div>';
				if(hml.indexOf('#PLATE_PIC_2#')>-1){
					hml = hml.replace('#PLATE_PIC_2#',tmpimg)
				}else{
					imgHml += tmpimg
				}
			}
			if(cont.pic_3){
				tmpimg = '<div><img src="'+(cont.pic_3.indexOf('http')==-1?(this.attach_url+cont.pic_3):cont.pic_3)+'" width="100%"/></div>';
				if(hml.indexOf('#PLATE_PIC_3#')>-1){
					hml = hml.replace('#PLATE_PIC_3#',tmpimg)
				}else{
					imgHml += tmpimg
				}
			}
			return imgHml+hml;
		}
	},
	computed:{
	},
	filters:{
	}
};
</script>
<style lang="less" scoped>
</style>




// WEBPACK FOOTER //
// src/components/NewsInfo.vue